import { render } from "./HelpScreen.vue?vue&type=template&id=3db7c331&scoped=true"
import script from "./HelpScreen.vue?vue&type=script&lang=js"
export * from "./HelpScreen.vue?vue&type=script&lang=js"

import "./HelpScreen.vue?vue&type=style&index=0&id=3db7c331&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db7c331"]])

export default __exports__